var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3914 13.9563L18.0343 24.2688C17.6329 24.6749 17.1021 24.8747 16.5713 24.8747C16.0405 24.8747 15.511 24.6732 15.1071 24.2704C14.2979 23.4647 14.2979 22.1596 15.1071 21.3539L21.9311 14.5622H2.07133C0.927508 14.5622 0 13.6405 0 12.4997C0 11.3588 0.927508 10.4372 2.07133 10.4372H21.9311L15.1084 3.6438C14.2992 2.83813 14.2992 1.53296 15.1084 0.727295C15.9175 -0.0783691 17.2284 -0.0783691 18.0375 0.727295L28.3947 11.0398C29.2006 11.8487 29.2006 13.1506 28.3914 13.9563Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.aa265f7b4bdedbf48bec8eac3d545429.svg";
export { ForwardRef as ReactComponent };